import { StoryState } from "../../state/types";
import globalStyle from '../../styles/common.module.css'
import style from './story.module.css'

export function Videos({items}: {items: StoryState["videos"]}) {
  if(!items || items.length === 0) return null;
  return (
    <>
    {items.map((item, index) => <Video item={item} key={index} />)}
    </>
  );
}

function Video({item}: { item: StoryState["videos"][number]}) {
  const urlParts = item.link.split('watch?v=')
  const embedUrl = urlParts.join('embed/')

  return (
    <>
      {item.blurb && (
        <div
          className={[globalStyle.bodySM, style.aboutBody].join(' ')}
          dangerouslySetInnerHTML={{ __html: item.blurb.html || '' }}
          style={{
            marginBottom: 'var(--space-l)',
          }}
        />
      )}
      <div className='video' style={{
        paddingBottom: 'var(--space-xl)',
        marginBottom: 'var(--space-xl)',
      }}>
        <iframe
          src={embedUrl}
          title='YouTube video'
          loading='lazy'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          referrerPolicy='strict-origin-when-cross-origin'
          allowFullScreen
          style={{
            width: '100%',
            aspectRatio: '16 / 9',
            height: 'auto',
            border: '0',
            display: 'block',
          }}
        ></iframe>
      </div>
    </>
  )
}